module.exports = __webpack_public_path__ + "img/y-104.49503be1.png";